export default __webpack_public_path__ + "static/media/crip.2c764b98.png";